import { Crown } from "lucide-react";
import { Link } from "react-router-dom";

// The Founder's Mark — rendered only for the Root Admin. Any other account,
// including a normal company admin, gets nothing. It is also the only entry
// point to the cross-company Estate View.
export default function FounderBadge({ user, size = "md", withLabel = true }) {
  if (!user?.is_root_admin) return null;
  const compact = size === "sm";
  return (
    <Link
      to="/app/estate"
      data-testid={compact ? "founder-badge-compact" : "founder-badge"}
      title="Root Admin · Directorate access — open Estate View"
      className={
        "inline-flex items-center gap-1.5 border-2 font-mono uppercase tracking-widest whitespace-nowrap transition-transform hover:-translate-y-0.5 " +
        (compact ? "px-1.5 py-0.5 text-[9px]" : "px-2 py-1 text-[10px]")
      }
      style={{
        borderColor: "#C9A356",
        background: "linear-gradient(135deg, #C9A356 0%, #E7CE94 55%, #B08D3F 100%)",
        color: "#030E2A",
        boxShadow: "0 1px 0 rgba(3,14,42,.35)",
      }}
    >
      <Crown className={compact ? "w-2.5 h-2.5" : "w-3 h-3"} strokeWidth={2.5} />
      {withLabel && <span>Founder</span>}
    </Link>
  );
}
